export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-search-24a97a91c962019f513aaf9a4f85dd13.svg";